module.exports = __webpack_public_path__ + "img/green.dcbafff3.png";